var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-icons"},[_c('router-link',{attrs:{"to":{ path: '/console/dashboard/property/' + _vm.propertyId + '/feedback' }}},[_c('img',{staticClass:"white",attrs:{"src":require("../assets/home2.svg")}})]),_c('br'),_c('router-link',{attrs:{"to":{
        path: '/console/dashboard/property/' + _vm.propertyId + '/feedbacksummary/list'
      }}},[_c('img',{staticClass:"white",attrs:{"src":require("../assets/news.svg")}})]),_c('br'),_c('router-link',{attrs:{"to":{
      path: '/console/dashboard/property/' + _vm.propertyId + '/feedback/list'
    }}},[_c('img',{staticClass:"white",attrs:{"src":require("../assets/feedback.svg")}})]),_c('br'),_c('router-link',{attrs:{"to":{
      path:
        '/console/dashboard/property/' +
        _vm.propertyId +
        '/feedback/customerjourney'
    }}},[_c('img',{staticClass:"white",attrs:{"src":require("../assets/cj.svg")}})]),_c('br'),_c('router-link',{attrs:{"to":{
      path:
        '/console/dashboard/property/' + _vm.propertyId + '/feedback/fileupload'
    }}},[_c('img',{staticClass:"white",attrs:{"src":require("../assets/upload.svg")}})]),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }